import { render, staticRenderFns } from "./dissertation.vue?vue&type=template&id=10903a40&scoped=true"
import script from "./dissertation.vue?vue&type=script&lang=js"
export * from "./dissertation.vue?vue&type=script&lang=js"
import style0 from "./dissertation.vue?vue&type=style&index=0&id=10903a40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10903a40",
  null
  
)

export default component.exports